import {Injectable} from "@angular/core";
import {Headers, Http} from "@angular/http";

import "rxjs/add/operator/toPromise";
import {Observable} from "rxjs/Rx";

import {Menu} from "./menu";

import myGlobals = require("../config");

@Injectable()
export class MenuService {
    private menuUrl = myGlobals.default.BASE_URL + "/menu/"; // URL to web api

    constructor(private http: Http) {}

    //Obtener todas los menus
    getMenus() {
        return this.http.get(this.menuUrl).map((response) => {
            const menus = response.json();
            localStorage.setItem("menus", JSON.stringify(menus));
            return menus;
        });
    }

    //Obtener menus desde localStorage
    getMenusFromStorage() {
        const menus = localStorage.getItem("menus");
        return menus ? JSON.parse(menus) : [];
    }

    //Verificar si una URL está habilitada para el usuario
    isUrlEnabled(url: string): boolean {
        const menus = this.getMenusFromStorage();
        return menus.some((menu: any) => menu.url === url && menu.estado);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/menu/menu.service.ts